/* stylelint-disable keyframes-name-pattern */

import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { accent0, accent1, accent2, accent4 } from '../globals/colors';

const strokeWidth = 4;
const radius = 20;
const circumference = 2 * Math.PI * radius;
const svgSize = radius + strokeWidth / 2;
const animationDuration = 2;

const animateRotation = keyframes`
    100% {
        transform: rotate(360deg);
    }
`;

const animateArcLength = keyframes`
    0% {
        stroke-dasharray: 0, ${circumference}px;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: ${circumference * 1.5}px, ${circumference}px;
        stroke-dashoffset: -${circumference * .5}px;
    }
    100% {
        stroke-dasharray: 0, ${circumference}px;
        stroke-dashoffset: -${circumference + 1}px;
    }
`;

const animateColors = keyframes`
    0%, 100% {
        stroke: ${accent0};
    }
    25% {
        stroke: ${accent1};
    }
    50% {
        stroke: ${accent2};
    }
    75% {
        stroke: ${accent4};
    }
`;

export const LoaderStyle = styled.div`
    align-items: center;
    display: flex;
    flex-grow: 1;
    justify-content: center;
    position: relative;
    visibility: ${({ show }) => show ? 'visible': 'hidden'};
    svg {
        animation: ${animateRotation} ${animationDuration}s linear infinite;
        height: ${({ size }) => size}rem;
        width: ${({ size }) => size}rem;
        circle {
            animation: ${animateArcLength} ${animationDuration}s ease-in-out infinite,
                ${animateColors} ${animationDuration * 4}s ease-in-out infinite;
            fill: none;
            stroke-linecap: round;
            stroke-width: ${strokeWidth}px;
            transform-origin: center;
        }
    }
`;

export function Loader({
    size = 10,
    ...otherProps
}) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        let mounted = true;

        setTimeout(() => {
            if (mounted) {
                setShow(true);
            }
        }, 200);

        return () => {
            mounted = false;
        };
    });

    return (
        <LoaderStyle
            show={show}
            size={size}
            {...otherProps}
        >
            <svg viewBox={`0 0 ${svgSize * 2} ${svgSize * 2}`}>
                <circle
                    cx={svgSize}
                    cy={svgSize}
                    r={radius}
                />
            </svg>
        </LoaderStyle>
    );
}

export default Loader;
